// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconSampleView_iconGrid__3HN1Q {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.IconSampleView_item__q1zdq {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/IconSampleView/IconSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AACF","sourcesContent":[".iconGrid {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconGrid": `IconSampleView_iconGrid__3HN1Q`,
	"item": `IconSampleView_item__q1zdq`
};
export default ___CSS_LOADER_EXPORT___;
